module.exports = __webpack_public_path__ + "static/media/container-006.68287d0b.jpg";